/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Notification,
  NotificationBulkInput,
  NotificationBulkResult,
  NotificationUnreadCount,
  Notifications,
  NotificationsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary List notifications
 */
export const notifications = (
    params?: MaybeRefOrGetter<NotificationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Notifications>(
      {url: `/notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getNotificationsQueryKey = (params?: MaybeRefOrGetter<NotificationsParams>,) => {
    return [
    'notifications', ...(params ? [params] : [])
    ] as const;
    }


export const getNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<NotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notifications>>> = ({ signal }) => notifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notifications>>, TError, TData>
}

export type NotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notifications>>>
export type NotificationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List notifications
 */

export function useNotifications<TData = Awaited<ReturnType<typeof notifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<NotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Archive the selected notifications
 */
export const archiveBulkNotifications = (
    notificationBulkInput: MaybeRefOrGetter<NotificationBulkInput>,
 signal?: AbortSignal
) => {
      notificationBulkInput = toValue(notificationBulkInput);

      return axiosClient<NotificationBulkResult>(
      {url: `/notifications/archive-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationBulkInput, signal
    },
      );
    }




export const getArchiveBulkNotificationsMutationKey = () => ['archiveBulkNotifications'] as const;

export const getArchiveBulkNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveBulkNotifications>>, TError,ArchiveBulkNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveBulkNotifications>>, TError,ArchiveBulkNotificationsMutationVariables, TContext> => {

const mutationKey = getArchiveBulkNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveBulkNotifications>>, ArchiveBulkNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  archiveBulkNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof archiveBulkNotifications>>>
    export type ArchiveBulkNotificationsMutationBody = NotificationBulkInput
    export type ArchiveBulkNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ArchiveBulkNotificationsMutationVariables = {data: NotificationBulkInput}

    /**
 * @summary Archive the selected notifications
 */
export const useArchiveBulkNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveBulkNotifications>>, TError,ArchiveBulkNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveBulkNotifications>>,
        TError,
        ArchiveBulkNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveBulkNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete all notifications
 */
export const destroyAllNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/destroy-all`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAllNotificationsMutationKey = () => ['destroyAllNotifications'] as const;

export const getDestroyAllNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAllNotifications>>, TError,void, TContext> => {

const mutationKey = getDestroyAllNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAllNotifications>>, void> = () => {


          return  destroyAllNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAllNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAllNotifications>>>

    export type DestroyAllNotificationsMutationError = ErrorType<StandardError>


    /**
 * @summary Delete all notifications
 */
export const useDestroyAllNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAllNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyAllNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete the selected notifications
 */
export const destroyBulkNotifications = (
    notificationBulkInput: MaybeRefOrGetter<NotificationBulkInput>,
 signal?: AbortSignal
) => {
      notificationBulkInput = toValue(notificationBulkInput);

      return axiosClient<NotificationBulkResult>(
      {url: `/notifications/destroy-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationBulkInput, signal
    },
      );
    }




export const getDestroyBulkNotificationsMutationKey = () => ['destroyBulkNotifications'] as const;

export const getDestroyBulkNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkNotifications>>, TError,DestroyBulkNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyBulkNotifications>>, TError,DestroyBulkNotificationsMutationVariables, TContext> => {

const mutationKey = getDestroyBulkNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyBulkNotifications>>, DestroyBulkNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  destroyBulkNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof destroyBulkNotifications>>>
    export type DestroyBulkNotificationsMutationBody = NotificationBulkInput
    export type DestroyBulkNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyBulkNotificationsMutationVariables = {data: NotificationBulkInput}

    /**
 * @summary Delete the selected notifications
 */
export const useDestroyBulkNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkNotifications>>, TError,DestroyBulkNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyBulkNotifications>>,
        TError,
        DestroyBulkNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyBulkNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark all notifications as read
 */
export const readAllNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/read-all`, method: 'PUT', signal
    },
      );
    }




export const getReadAllNotificationsMutationKey = () => ['readAllNotifications'] as const;

export const getReadAllNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext> => {

const mutationKey = getReadAllNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAllNotifications>>, void> = () => {


          return  readAllNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadAllNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readAllNotifications>>>

    export type ReadAllNotificationsMutationError = ErrorType<StandardError>


    /**
 * @summary Mark all notifications as read
 */
export const useReadAllNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readAllNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReadAllNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark the selected notifications as read
 */
export const readBulkNotifications = (
    notificationBulkInput: MaybeRefOrGetter<NotificationBulkInput>,
 signal?: AbortSignal
) => {
      notificationBulkInput = toValue(notificationBulkInput);

      return axiosClient<NotificationBulkResult>(
      {url: `/notifications/read-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationBulkInput, signal
    },
      );
    }




export const getReadBulkNotificationsMutationKey = () => ['readBulkNotifications'] as const;

export const getReadBulkNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readBulkNotifications>>, TError,ReadBulkNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readBulkNotifications>>, TError,ReadBulkNotificationsMutationVariables, TContext> => {

const mutationKey = getReadBulkNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readBulkNotifications>>, ReadBulkNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  readBulkNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readBulkNotifications>>>
    export type ReadBulkNotificationsMutationBody = NotificationBulkInput
    export type ReadBulkNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReadBulkNotificationsMutationVariables = {data: NotificationBulkInput}

    /**
 * @summary Mark the selected notifications as read
 */
export const useReadBulkNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readBulkNotifications>>, TError,ReadBulkNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readBulkNotifications>>,
        TError,
        ReadBulkNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getReadBulkNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Move the selected notifications back to the inbox
 */
export const unarchiveBulkNotifications = (
    notificationBulkInput: MaybeRefOrGetter<NotificationBulkInput>,
 signal?: AbortSignal
) => {
      notificationBulkInput = toValue(notificationBulkInput);

      return axiosClient<NotificationBulkResult>(
      {url: `/notifications/unarchive-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationBulkInput, signal
    },
      );
    }




export const getUnarchiveBulkNotificationsMutationKey = () => ['unarchiveBulkNotifications'] as const;

export const getUnarchiveBulkNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkNotifications>>, TError,UnarchiveBulkNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkNotifications>>, TError,UnarchiveBulkNotificationsMutationVariables, TContext> => {

const mutationKey = getUnarchiveBulkNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveBulkNotifications>>, UnarchiveBulkNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unarchiveBulkNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveBulkNotifications>>>
    export type UnarchiveBulkNotificationsMutationBody = NotificationBulkInput
    export type UnarchiveBulkNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnarchiveBulkNotificationsMutationVariables = {data: NotificationBulkInput}

    /**
 * @summary Move the selected notifications back to the inbox
 */
export const useUnarchiveBulkNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkNotifications>>, TError,UnarchiveBulkNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveBulkNotifications>>,
        TError,
        UnarchiveBulkNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveBulkNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark the selected notifications as unread
 */
export const unreadBulkNotifications = (
    notificationBulkInput: MaybeRefOrGetter<NotificationBulkInput>,
 signal?: AbortSignal
) => {
      notificationBulkInput = toValue(notificationBulkInput);

      return axiosClient<NotificationBulkResult>(
      {url: `/notifications/unread-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationBulkInput, signal
    },
      );
    }




export const getUnreadBulkNotificationsMutationKey = () => ['unreadBulkNotifications'] as const;

export const getUnreadBulkNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadBulkNotifications>>, TError,UnreadBulkNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unreadBulkNotifications>>, TError,UnreadBulkNotificationsMutationVariables, TContext> => {

const mutationKey = getUnreadBulkNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreadBulkNotifications>>, UnreadBulkNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unreadBulkNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreadBulkNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof unreadBulkNotifications>>>
    export type UnreadBulkNotificationsMutationBody = NotificationBulkInput
    export type UnreadBulkNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnreadBulkNotificationsMutationVariables = {data: NotificationBulkInput}

    /**
 * @summary Mark the selected notifications as unread
 */
export const useUnreadBulkNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadBulkNotifications>>, TError,UnreadBulkNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unreadBulkNotifications>>,
        TError,
        UnreadBulkNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getUnreadBulkNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Unread notification count
 */
export const notificationsUnreadCount = (

 signal?: AbortSignal
) => {


      return axiosClient<NotificationUnreadCount>(
      {url: `/notifications/unread-count`, method: 'GET', signal
    },
      );
    }




export const getNotificationsUnreadCountQueryKey = () => {
    return [
    'notifications','unread-count'
    ] as const;
    }


export const getNotificationsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof notificationsUnreadCount>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getNotificationsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsUnreadCount>>> = ({ signal }) => notificationsUnreadCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsUnreadCount>>, TError, TData>
}

export type NotificationsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsUnreadCount>>>
export type NotificationsUnreadCountQueryError = ErrorType<StandardError>


/**
 * @summary Unread notification count
 */

export function useNotificationsUnreadCount<TData = Awaited<ReturnType<typeof notificationsUnreadCount>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete a notification
 */
export const destroyNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/notifications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyNotificationMutationKey = () => ['destroyNotification'] as const;

export const getDestroyNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyNotification>>, TError,DestroyNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyNotification>>, TError,DestroyNotificationMutationVariables, TContext> => {

const mutationKey = getDestroyNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyNotification>>, DestroyNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyNotification>>>

    export type DestroyNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyNotificationMutationVariables = {id: string}

    /**
 * @summary Delete a notification
 */
export const useDestroyNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyNotification>>, TError,DestroyNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyNotification>>,
        TError,
        DestroyNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive a notification
 */
export const archiveNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Notification>(
      {url: `/notifications/${id}/archive`, method: 'PUT', signal
    },
      );
    }




export const getArchiveNotificationMutationKey = () => ['archiveNotification'] as const;

export const getArchiveNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveNotification>>, TError,ArchiveNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveNotification>>, TError,ArchiveNotificationMutationVariables, TContext> => {

const mutationKey = getArchiveNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveNotification>>, ArchiveNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveNotification>>>

    export type ArchiveNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ArchiveNotificationMutationVariables = {id: string}

    /**
 * @summary Archive a notification
 */
export const useArchiveNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveNotification>>, TError,ArchiveNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveNotification>>,
        TError,
        ArchiveNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark notification as read
 */
export const readNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Notification>(
      {url: `/notifications/${id}/read`, method: 'PUT', signal
    },
      );
    }




export const getReadNotificationMutationKey = () => ['readNotification'] as const;

export const getReadNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readNotification>>, TError,ReadNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readNotification>>, TError,ReadNotificationMutationVariables, TContext> => {

const mutationKey = getReadNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readNotification>>, ReadNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  readNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof readNotification>>>

    export type ReadNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReadNotificationMutationVariables = {id: string}

    /**
 * @summary Mark notification as read
 */
export const useReadNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readNotification>>, TError,ReadNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readNotification>>,
        TError,
        ReadNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getReadNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Move a notification back to the inbox
 */
export const unarchiveNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Notification>(
      {url: `/notifications/${id}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveNotificationMutationKey = () => ['unarchiveNotification'] as const;

export const getUnarchiveNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveNotification>>, TError,UnarchiveNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveNotification>>, TError,UnarchiveNotificationMutationVariables, TContext> => {

const mutationKey = getUnarchiveNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveNotification>>, UnarchiveNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unarchiveNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveNotification>>>

    export type UnarchiveNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnarchiveNotificationMutationVariables = {id: string}

    /**
 * @summary Move a notification back to the inbox
 */
export const useUnarchiveNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveNotification>>, TError,UnarchiveNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveNotification>>,
        TError,
        UnarchiveNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark notification as unread
 */
export const unreadNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Notification>(
      {url: `/notifications/${id}/unread`, method: 'PUT', signal
    },
      );
    }




export const getUnreadNotificationMutationKey = () => ['unreadNotification'] as const;

export const getUnreadNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadNotification>>, TError,UnreadNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unreadNotification>>, TError,UnreadNotificationMutationVariables, TContext> => {

const mutationKey = getUnreadNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreadNotification>>, UnreadNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unreadNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreadNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unreadNotification>>>

    export type UnreadNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnreadNotificationMutationVariables = {id: string}

    /**
 * @summary Mark notification as unread
 */
export const useUnreadNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadNotification>>, TError,UnreadNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unreadNotification>>,
        TError,
        UnreadNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getUnreadNotificationMutationOptions(options), queryClient);
    }
